import axios from "axios";
import Swal from "sweetalert2";

export const processAsetecPayment = async (order) => {
    try {
        // Show confirmation dialog first
        const responseAlert = await Swal.fire({
            title: "¡Atencion!",
            text: "Este es un pago interno de ASETEC. Por favor, asegúrese de que el pago ha sido procesado en el sistema antes de continuar.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
        });

        if (!responseAlert.isConfirmed) {
            return false;
        }

        let idForStateApproved = (parseInt(order.id) + 1).toString();

        // First API call - setaproved
        const approvedResponse = await axios({
            method: "POST",
            url: "https://kakaomarket.cr/wp-json/misc/v1/setaproved",
            data: {
                order_id: idForStateApproved,
                transaction_id: "Pagos internos ASETEC",
            },
        });

        if (approvedResponse.status !== 200) {
            throw new Error("Failed to set order as approved");
        }

        // Second API call - updateorderstatus
        const statusResponse = await axios({
            method: "POST",
            url: "https://kakaomarket.cr/wp-json/sellerconsole/v1/updateorderstatus",
            data: {
                orderId: order.id,
                status: {
                    value: "processing",
                    label: "PROCESANDO",
                    color: "#00B8D4",
                },
            },
        });

        if (statusResponse.status !== 200) {
            throw new Error("Failed to update order status");
        }

        // Show success message and reload page
        await Swal.fire(
            "¡Éxito!",
            "Se procesó correctamente. No se necesitó transaccion bancaria.",
            "success"
        );
        
        window.location.reload();
        return true;

    } catch (error) {
        console.error("Error processing ASETEC payment:", error);
        await Swal.fire(
            "¡Error!",
            "Ocurrió un error al procesar el pago de ASETEC.",
            "error"
        );
        return false;
    }
};